export default {
  "home.heading.default": "มาคุยกัน",
  "home.heading.loading": "กำลังเปิดห้อง...",
  "home.heading.join": "พร้อมเข้าห้องยัง?",
  "home.heading.joined": "เข้ามาแล้ว",
  "home.heading.pending": "รอโฮสต์แป๊บ",
  "home.body.default": "สร้างห้อง แปะลิงก์ แล้วชิลเลย",
  "home.body.loading": "แป๊บนึงนะ กำลังเตรียมห้องให้",
  "home.body.join": "เช็คกล้องกับไมค์ให้ชัวร์ แล้วกดเข้าเลย",
  "home.body.joined": "ห้องพร้อมแล้ว แชร์ลิงก์หรือเริ่มคุยได้เลย",
  "home.body.joined_in_room": "อยู่ในห้องแล้ว — ลุยเลยหรือจะแชร์ลิงก์ก่อนก็ได้",
  "home.body.pending": "ห้องล็อคอยู่ รอโฮสต์กดรับนะ",
  "home.cta.create": "สร้างห้อง",
  "home.cta.join": "เข้าห้อง",
  "home.cta.enter": "เข้าห้อง",
  "home.cta.creating": "กำลังสร้าง...",
  "home.cta.joining": "กำลังเข้า...",
  "home.cta.opening": "กำลังเปิด...",
  "home.cta.pending": "รอโฮสต์รับ...",
  "home.copy_link": "ก๊อปลิงก์",
  "home.copied": "ก๊อปแล้ว!",
  "home.leave": "ออกห้อง",
  "home.back": "กลับ",
  "home.no_participants": "ยังไม่มีใครมา",
  "home.join_by_code": "ใส่โค้ดเข้าห้อง",
  "home.code_placeholder": "ใส่โค้ด",
  "home.name_placeholder": "ชื่อของคุณ",
  "home.people_one": "คน",
  "home.people_other": "คน",
  "home.marketing.invite.title": "สร้างห้อง\nแล้วแชร์ลิงก์เลย",
  "home.marketing.invite.body": "กดปุ่มเดียวเริ่มได้เลย แชร์ลิงก์ให้เพื่อนเข้าได้ทันที ไม่ต้องโหลดแอป ไม่ต้องสมัคร",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "ปรับลุค\nได้ตามใจ",
  "home.marketing.look.body": "แต่งสี ทำหน้าเนียน ใส่ขอบดำ — หรือจะเบลอหน้าไปเลยก็ได้ กล้องคุณ สไตล์คุณ",
  "home.marketing.host.title": "พื้นที่ของคุณ\nกฎของคุณ",
  "home.marketing.host.body": "ล็อคห้อง ปิดไมค์ หรือเตะคนออก โฮสต์คุมได้หมด",
  "home.marketing.host.locked": "ล็อคห้องแล้ว",
  "home.marketing.host.waiting_to_join": "รอเข้าห้อง",
  "home.marketing.host.wants_to_join": "ขอเข้าห้อง",
  "home.marketing.anything.title": "ใช้ทำอะไรก็ได้จริงๆ",
  "home.marketing.anything.body": "ติวหนังสือ เล่นเกม คุยงาน ดูหนังด้วยกัน — หรือแค่นั่งชิลเฉยๆ ก็ได้",
  "home.marketing.use_case.study_group": "📚 ติวหนังสือ",
  "home.marketing.use_case.game_night": "🎮 เล่นเกม",
  "home.marketing.use_case.standup": "💼 คุยงาน",
  "home.marketing.use_case.watch_party": "🍿 ดูหนัง",
  "home.marketing.use_case.catch_up": "☕ อัปเดตชีวิต",
  "home.marketing.use_case.jam_session": "🎸 เล่นดนตรี",
  "home.marketing.use_case.book_club": "📖 คุยเรื่องหนังสือ",
  "home.marketing.use_case.coworking": "💻 นั่งทำงานด้วยกัน",
  "ended.heading": "จบสายแล้ว",
  "ended.left": "คุณออกจากห้องแล้ว",
  "ended.room_ended": "{title} จบลงแล้ว",
  "ended.rejoin": "เข้าใหม่",
  "ended.rejoining": "กำลังเข้าใหม่...",
  "ended.home": "กลับหน้าแรก",
  "call.connecting": "กำลังเชื่อมต่อ",
  "call.waiting": "รอคนอื่นแป๊บ",
  "call.invite_code": "โค้ดเชิญ",
  "call.audio_on": "เปิดเสียง",
  "call.muted": "ปิดไมค์อยู่",
  "call.listening": "กำลังฟัง",
  "call.audio_muted": "ปิดเสียงอยู่",
  "call.speaking": "กำลังพูด",
  "call.you": "คุณ",
  "call.you_label": "คุณ",
  "call.you_suffix": "(คุณ)",
  "call.chat_placeholder": "พิมพ์ข้อความ...",
  "call.guest": "เกสต์",
  "call.room_fallback": "ห้อง",
  "call.focus_view": "มุมมองโฟกัส",
  "call.grid_view": "มุมมองกริด",
  "call.swap_main_video": "สลับวิดีโอหลัก",
  "call.open_chat": "เปิดแชท",
  "call.close_chat": "ปิดแชท",
  "call.leave_room": "ออกห้อง",
  "call.confirm_leave": "ออกเลยมั้ย?",
  "call.mic_on": "เปิดไมค์",
  "call.muted_label": "ปิดไมค์อยู่",
  "call.camera_off": "ปิดกล้อง",
  "call.connect_failed": "เชื่อมต่อไม่ติด — เช็คเน็ตแล้วลองใหม่นะ",
  "call.camera_access_failed": "เข้าถึงกล้องไม่ได้ ลองเช็คสิทธิ์ในเบราว์เซอร์แล้วเข้าใหม่ดูนะ",
  "call.recording_failed": "อัดวิดีโอไม่ได้ แต่ยังคุยต่อได้ปกตินะ",
  "call.initialize_failed": "มีปัญหาตอนเริ่มสาย ลองรีเฟรชแล้วเข้าใหม่นะ",
  "call.participants": "คนในห้อง",
  "call.open_participants": "ดูคนในห้อง",
  "call.close_participants": "ปิดรายชื่อ",
  "call.lock_room": "ล็อคห้อง",
  "call.unlock_room": "ปลดล็อคห้อง",
  "call.locked": "ล็อคอยู่",
  "call.unlocked": "เปิดอยู่",
  "call.kick_member": "เตะออกจากห้อง",
  "call.mute_member": "ปิดไมค์",
  "call.unmute_member": "เปิดไมค์",
  "call.muted_by_host": "โฮสต์ปิดไมค์อยู่",
  "call.waiting_to_join": "รอเข้าห้อง",
  "call.approve": "ให้เข้า",
  "call.deny": "ไม่ให้เข้า",
  "call.profile_actions": "จัดการโปรไฟล์",
  "call.profile_in_room": "อยู่ในห้อง",
  "call.profile_role_host": "โฮสต์",
  "call.profile_role_you": "คุณ",
  "call.profile_action_mute": "ปิดเสียงคนนี้",
  "call.profile_action_mute_meta": "ปิดแค่ฝั่งเรา — เค้าไม่รู้หรอก",
  "call.profile_action_dm": "ทัก DM",
  "call.profile_action_dm_meta": "แชทส่วนตัวแบบ 1:1",
  "call.profile_action_view": "ดูโปรไฟล์เต็ม",
  "call.profile_action_view_meta": "ไบโอ ภาษา ห้องที่เคยเข้า",
  "call.profile_action_report": "รีพอร์ต",
  "call.profile_action_report_meta": "แจ้งให้แอดมินตรวจสอบ",
  "call.profile_sheet_close": "ปิดหน้าจัดการโปรไฟล์",
  "call.profile_open_actions": "เปิดหน้าจัดการโปรไฟล์",
  "call.dm_title": "ข้อความส่วนตัว",
  "call.dm_back": "กลับ",
  "call.dm_close": "ปิดแชทส่วนตัว",
  "call.dm_status_online": "ออนไลน์",
  "call.dm_in_room_with": "อยู่ในห้องนี้",
  "call.dm_private_label": "แชทส่วนตัว",
  "call.dm_private_meta": "เห็นกันแค่สองคนนะ",
  "call.dm_input_placeholder": "ส่งข้อความส่วนตัว…",
  "call.dm_send": "ส่ง",
  "call.dm_just_now": "เมื่อกี้",
  "call.dm_seen_just_now": "เพิ่งอ่าน",
  "call.dm_typing": "{name} กำลังพิมพ์…",
  "call.dm_minimize": "ย่อหน้าต่าง",
  "call.dm_active_indicator": "เปิดแชท",
  "call.dm_unread_messages": "ยังไม่อ่าน {count} ข้อความ",
  "call.dm_toast_tap_to_open": "แตะเพื่อเปิด",
  "call.dm_reopen_aria": "เปิดแชทกับ {name} อีกครั้ง",
  "home.join_denied": "โฮสต์ไม่ให้เข้านะ",
  "home.error.room_not_found": "ไม่มีโค้ดห้องนี้นะ",
  "home.error.profile_required": "ตั้งค่าโปรไฟล์ก่อนไปต่อนะ",
  "home.cta.set_up_profile": "ตั้งค่าโปรไฟล์",
  "home.profile_trigger_new": "แตะเพื่อเพิ่มข้อมูล",
  "home.profile_trigger_new_aria": "ตั้งค่าโปรไฟล์",
  "home.profile_trigger_edit_aria": "แก้โปรไฟล์",
  "profile.eyebrow_new": "ทักทาย",
  "profile.eyebrow_edit": "โปรไฟล์ของคุณ",
  "profile.title_new": "แต่งโปรไฟล์ในแบบคุณ",
  "profile.title_edit": "แก้โปรไฟล์",
  "profile.subtitle": "ใส่ข้อมูลนิดนึง คนอื่นจะได้รู้ว่าคุยกับใครอยู่",
  "profile.add_photo": "เพิ่มรูป",
  "profile.add_photo_soon": "ระบบรูปกำลังตามมา",
  "profile.photo_empty": "แตะเพื่อเพิ่มรูป",
  "profile.photo_ready": "รูปพร้อมแล้ว",
  "profile.photo_save_first": "เซฟโปรไฟล์ก่อนอัปรูปนะ",
  "profile.photo_crop_caption": "จัดกรอบรูป",
  "profile.photo_auto_caption": "ลากและซูมได้เลย เดี๋ยวระบบเซฟให้ออโต้",
  "profile.photo_upload": "อัปรูป",
  "profile.photo_replace": "เปลี่ยนรูป",
  "profile.photo_remove": "ลบรูป",
  "profile.photo_cancel": "ยกเลิก",
  "profile.photo_save": "เซฟรูป",
  "profile.photo_uploading": "กำลังอัปรูป…",
  "profile.photo_removing": "กำลังลบรูป…",
  "profile.photo_choose_another": "เลือกรูปอื่น",
  "profile.photo_drag_hint": "ลากรูปให้พอดีในวงกลม ระบบจะเซฟให้ออโต้เลย",
  "profile.photo_zoom": "ซูม",
  "profile.photo_horizontal": "ครอปแนวนอน",
  "profile.photo_vertical": "ครอปแนวตั้ง",
  "profile.name_label": "ชื่อ",
  "profile.name_placeholder": "ให้เราเรียกคุณว่าอะไรดี?",
  "profile.gender_label": "ฉันเป็น",
  "profile.gender.woman": "ผู้หญิง",
  "profile.gender.man": "ผู้ชาย",
  "profile.gender.unspecified": "ไม่ระบุ",
  "profile.bio_label": "ไบโอ",
  "profile.bio_optional": "ไม่บังคับ",
  "profile.bio_placeholder": "ภาษาที่พูด สิ่งที่ชอบ หรืออะไรก็ได้…",
  "profile.cta_new": "ลุยเลย",
  "profile.cta_edit": "เซฟ",
  "profile.saving": "กำลังเซฟ…",
  "profile.close": "ปิด",
  "profile.error.save_failed": "เซฟโปรไฟล์ไม่ได้ ลองใหม่อีกทีนะ",
  "profile.error.avatar_invalid_type": "เลือกรูป PNG, JPEG, GIF หรือ WebP นะ",
  "profile.error.avatar_too_large": "เลือกรูปขนาดไม่เกิน 5 MB นะ",
  "profile.error.avatar_too_small": "เลือกรูปขนาด 96x96 พิกเซลขึ้นไปนะ",
  "profile.error.avatar_load_failed": "อ่านไฟล์รูปไม่ได้ ลองเปลี่ยนรูปดูนะ",
  "profile.error.avatar_failed": "อัปรูปไม่ได้ ลองใหม่อีกทีนะ",
  "profile.error.avatar_remove_failed": "ลบรูปไม่ได้ ลองใหม่อีกทีนะ",
  "effects.title": "เอฟเฟกต์",
  "effects.soft": "หน้าเนียน",
  "effects.vignette": "ขอบดำ",
  "effects.face": "เบลอหน้า",
  "effects.face_preview_only": "เบลอหน้า (ดูได้แค่เรา)",
  "effects.face_viewer_side": "เบลอหน้า (คนอื่นเห็น)",
  "effects.face_strength": "ระดับความเบลอ",
  "effects.grade.off": "ปิด",
  "effects.grade.pop": "สดใส",
  "effects.grade.warm": "โทนอุ่น",
  "effects.grade.cool": "โทนเย็น",
  "effects.grade.bw": "ขาวดำ",
  "camera.off": "ปิดกล้องอยู่",
  "camera.check": "เช็คกล้องแป๊บ",
  "camera.retry": "ลองเปิดกล้องใหม่",
  "camera.ready": "กล้องพร้อม",
  "camera.idle.title": "เปิดกล้องหน่อย",
  "camera.idle.hint": "เดี๋ยวเราจะขอสิทธิ์เข้าถึงกล้องจากเบราว์เซอร์นะ",
  "camera.idle.button": "เปิดกล้อง",
  "camera.status.idle": "รอคุณอยู่",
  "camera.status.off": "ปิดกล้องอยู่",
  "camera.status.loading": "กำลังขอสิทธิ์เข้าถึงกล้อง...",
  "camera.status.denied": "อนุญาตให้เบราว์เซอร์เข้าถึงกล้องก่อน แล้วลองใหม่นะ",
  "camera.status.error": "พรีวิวกล้องไม่ได้ ลองใหม่อีกที",
  "camera.status.unsupported": "เบราว์เซอร์นี้ไม่รองรับการเปิดกล้อง",
  "camera.status.insecure": "การเปิดกล้องต้องใช้ HTTPS หรือ localhost",
  "camera.status.attach_failed": "เปิดพรีวิวกล้องไม่ได้ ลองใหม่อีกทีนะ",
  "camera.guest_name_placeholder": "ชื่อเกสต์",
  "camera.flip": "สลับกล้อง",
  "camera.save_name": "เซฟ",
  "camera.edit_name": "แก้ชื่อ",
  "mic.on": "ปิดไมค์",
  "mic.off": "เปิดไมค์",
  "video.on": "ปิดกล้อง",
  "video.off": "เปิดกล้อง",
  "chat.title": "แชท",
  "chat.close": "ปิดแชท",
  "chat.loading": "กำลังโหลด...",
  "chat.load_earlier": "โหลดข้อความก่อนหน้า",
  "chat.empty": "ยังไม่มีข้อความ",
  "chat.send_error": "ส่งข้อความไม่ไป — ลองใหม่นะ",
  "chat.input_placeholder": "พิมพ์ข้อความ...",
  "room.host": "โฮสต์",
  "app.room_default_title": "สร้างห้อง",
  "app.chat_connection_rejected": "เชื่อมต่อแชทไม่ได้ — ลองรีเฟรชดูนะ",
  "app.copy_failed": "ก๊อปลิงก์ไม่ได้ ลองคลุมดำแล้วก๊อปเองดูนะ",
  "app.chat_not_connected": "แชทยังไม่เชื่อมต่อ รอแป๊บนึงแล้วลองใหม่นะ",
  "footer.terms": "ข้อตกลงและเงื่อนไข",
  "footer.copyright": "© 2026 Yano.AI"
}
